import React,{Component} from 'react'
import AOS from 'aos'
import {Link} from 'react-router-dom'
import Map from '../components/Map'

const center = { lat: 12.9288512, lng: 77.6274287 }
const mapProps = {
    options: {
        center,
        zoom: 18,
    },
    onMount: map => {
        new window.google.maps.Marker({
            position: center,
            map,
            title: 'Hubler',
        })
    },
}

export default class ContactUs extends Component{
    componentDidMount() {
        this.aos = AOS;
        this.aos.init({
            duration: 1500,
            once: true,
        });
    }
    render(){
        return <div className={'contact-us-main-page'}>
            <div className={'heading'}>
                <div className={'contact'}>Contact Us</div>
            </div>
          {/*  <div className={'section-heading'}>
                <div className={'head'}>Reason for Inquiry</div>
                <p>Please select the purpose for your inquiry.</p>
            </div>*/}
            <div className={'inquiry'}>
                {/*<div className={'request-a-demo sales-inquiry inquiry-cls'}>
                    <div className={'image'}></div>
                    <div className={'head'}>Request a Demo</div>
                    <p>Request a product demo to see for yourself the industry loved Hubler features; Have a thousand queries? Shoot.</p>
                    <Link to="demo">Request a Demo</Link>
                </div>*/}
                <div className={'sales-inquiry inquiry-cls'}>
                    <div className={'image'}></div>
                    <div className={'head'}>Sales Inquiry</div>
                    <p>Reach out to our Sales team directly for immediate assistance with all sales-related inquiries.</p>
                    <Link to="/sales">Sales Inquiry</Link>
                </div>
                <div className={'customer-support inquiry-cls'}>
                    <div className={'image'}></div>
                    <div className={'head'}>Customer Support</div>
                    <p>Get in touch with customer support for assistance with your Hubler product queries.</p>
                    <Link to="/customerSupport">Customer Support</Link>
                </div>
            </div>
            <div className={'company-info-address'}>
                <div className={'company-info-address-cls'}>
                <div className={'address-cls'}>
                    <div className={'address-one address-info'}>
                        <div className={'head'}>India</div>
                        <div className={'address'}>Hubbler Private Limited</div>
                        <div className={'address'}>No.87, Anugraha Building, 4th Floor,</div>
                        <div className={'address'}>7th Cross, 4th B Block,</div>
                        <div className={'address'}>Koramangala, Bangalore - 560034</div>
                        <div className={'address'}>Landline: +91 80 4200 1415</div>
                        <div className={'address email'}>Email:
                            <a href="mailto: connect@hubbler.mobi">connect@hubbler.mobi</a>
                        </div>
                    </div>
                    <div className={'address-two address-info'}>
                        <div className={'head'}>USA</div>
                        <div className={'address'}>Hubler LLC</div>
                        <div className={'address'}>8 The Green, Suite R, Dover</div>
                        <div className={'address'}>Zip Code 19901</div>
                        <div className={'address email'}>Email:
                            <a href="mailto: connect@hubbler.mobi">connect@hubbler.mobi</a>
                        </div>
                    </div>
                </div>
                <div className={'map'}>
{/*
                    <div ref={map => this.mapElement = map} style={{height: '100%'}}></div>
*/}
                    <Map id="contactMap" {...mapProps} />
                </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/contactUs.js